// authReducer.js
import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  practices: [], // Stores all practices
  selectedPractice: null, // Currently selected practice
  locations: [],
  selectedLocation: "",
  showLocationModal: false,
};

export const practiceSlice = createSlice({
  name: "practice",
  initialState,
  reducers: {
    setPractices: (state, action) => {
      state.practices = action.payload;
      state.selectedPractice = action.payload[0]?.id;
      state.locations = action.payload[0].locations;
      if (state.selectedLocation === "")
        state.selectedLocation = action.payload[0]?.locations[0]?.location?.id;
    },
    setSelectedPractice: (state, action) => {
      state.selectedPractice = action.payload;
    },

    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
    setLocations: (state, action) => {
      state.locations = action.payload;
    },
    setOpenLocationModal: (state, action) => {
      state.showLocationModal = true;
    },
    setCloseLocationModal: (state, action) => {
      state.showLocationModal = false;
    },
  },
});

export const {
  setPractices,
  setLocations,
  setSelectedPractice,
  setSelectedLocation,
  setOpenLocationModal,
  setCloseLocationModal,
} = practiceSlice.actions;
export default practiceSlice.reducer;


// ✅ Selector to get all locations
export const selectAllLocations = (state) => state.practice?.locations || [];

// ✅ Memoized selector to get a location by ID
export const selectLocationById = createSelector(
  [selectAllLocations, (_, locationId) => locationId],
  (locations, locationId) =>
    locations.find(({ location }) => location.id === locationId) || null
);
